import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";

// Shared across the all-role shortcut and Admin tab. Backend enforces each
// account's visibility; an unread count never exposes other users' records.
export default function NotificationUnreadDot() {
  const [unread, setUnread] = useState(false);
  useEffect(() => {
    let active = true;
    const refresh = () => {
      api.get("/notifications/history")
        .then(response => {
          if (active) setUnread((response.data || []).some(item => !item.read));
        })
        .catch(() => { if (active) setUnread(false); });
    };
    refresh();
    const timer = window.setInterval(refresh, 30000);
    const onFocus = () => refresh();
    window.addEventListener("focus", onFocus);
    window.addEventListener("freshcare-notifications-changed", onFocus);
    return () => {
      active = false;
      window.clearInterval(timer);
      window.removeEventListener("focus", onFocus);
      window.removeEventListener("freshcare-notifications-changed", onFocus);
    };
  }, []);
  return unread ? <span aria-label="Unread notifications" data-testid="notification-unread-dot"
    className="pointer-events-none absolute -right-1 -top-1 h-2.5 w-2.5 rounded-full border-2 border-white bg-red-600" /> : null;
}
